import { defineMessages } from 'react-intl-next';
export let ViewFormMessage = /*#__PURE__*/function (ViewFormMessage) {
  ViewFormMessage["HiddenSection"] = "HiddenSection";
  return ViewFormMessage;
}({});
export const IntlViewFormMessages = defineMessages({
  [ViewFormMessage.HiddenSection]: {
    id: 'form-system.viewForm.HiddenSection',
    defaultMessage: 'Hidden section - Conditions apply'
  }
});